module.exports = __webpack_public_path__ + "static/img/chong.ab6012b1.png";